* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: calc(7 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer));
  display: flex;
  flex-direction: column;

  height: 100%;
}

gz-label-switch {
  --label-width: auto;
  --container-width: auto;
}

#risk-incident-side-panel-accordions {
  overflow: auto;
  #risk-incident-side-panel-accordion-0 {
    span[slot='dynamic-title-content'] {
      gz-icon-label[icon='icon-root-cause-risks'] {
        display: block;
        width: calc(var(--spacer) * 3);
        height: calc(var(--spacer) * 1.25);
        content: '';
        background: url("data:image/svg+xml,%3Csvg version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' width='24px' height='10px' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='matrix(1 0 0 1 -1440 -354 )'%3E%3Cpath d='M 11.2 0 L 10.072 1.175 L 12.936000000000002 4.166666666666667 L 3.2 4.166666666666667 L 3.2 5.833333333333334 L 12.936000000000002 5.833333333333334 L 10.064000000000002 8.825 L 11.2 10 L 16 5 L 11.2 0 Z M 1.6 0 L 0 0 L 0 10 L 1.6 10 L 1.6 0 Z ' fill-rule='nonzero' fill='%237f7f7f' stroke='none' transform='matrix(1 0 0 1 1440 354 )' /%3E%3C/g%3E%3C/svg%3E");
      }
    }
  }
}

.title-header {
  padding-bottom: calc(2 * var(--spacer));
  display: flex;
  flex-direction: column;
  gap: calc(2 * var(--spacer));
}

.side-panel-title {
  font-size: var(--body-size-xxlarge);
  font-weight: 500;
  color: var(--main-titles-inputs-600);
}

// ToDo: from here

.risk-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: calc(var(--spacer));
}

.risk-name {
  width: 100%;
}

.risk-node-name {
  display: flex;
  justify-self: end;
}

gz-accordion {
  padding-top: calc(var(--spacer) * 2);
  --margin--compact-accordion: 0;
}

.accordion-slot {
  display: flex;
  width: calc(100% - 26px);
}

.accordion-count {
  padding-left: calc(var(--spacer) / 2);

  display: flex;
  align-items: center;
  justify-items: center;
}

.accordion-title {
  text-transform: uppercase;
  font-size: var(--body-size-small);
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-items: center;
}

.accordion-title,
.accordion-count {
  color: var(--chart-300-icon-buttons);
  width: auto;
}

.risk-side-menu-content {
  display: flex;
  padding-top: var(--spacer);
  color: var(--main-titles-inputs-600);
}

.risk-side-menu-labeled-content {
  padding-right: calc(var(--spacer) * 1.5);
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacer);
  gap: calc(var(--spacer) * 2);
  flex-grow: 1;
  overflow: hidden;
}

gz-inline-row-actions {
  flex-basis: min-content;
  margin-left: auto;
  margin-right: 0;
  padding-right: 0;
}

.label-tooltip-node-name {
  flex-basis: 50%;
  display: grid;
}

.label-tooltip-risk-name {
  flex-basis: 50%;
}

#risk-incident-side-panel-label-switch {
  width: 100%;
}

.is-displayed {
  display: block;
}

.is-not-displayed {
  display: none;
}

gz-title {
  margin-bottom: var(--spacer);
}

#license-required-message {
  margin-bottom: calc(var(--spacer) * 2);
}
